import { useState} from "react";
import {Button} from "@mui/material";
import {Col, Row} from "react-bootstrap";
import style from './CartItem.module.css';
import {CartItemProps} from "../Interface";
import {AxiosError, AxiosResponse} from "axios";
import {useNavigate, useParams} from "react-router";
import trash from '../../../Assets/Images/trash.png';
import {DynamicObject} from "../../../models/General";
import useHttp from "../../../Hooks/use-http/use-http";
import {configDeleteCartItemApi} from "../../../Api/api.config";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { getGeneralImage } from "../../../Helpers/functions";


const CartItem = (props: CartItemProps) => {

    let {memberId, cartId, identification} = useParams();
    let navigate = useNavigate()
    const {t} = useTranslation()

    /*-----------------------------
     *           STATES
     * ----------------------------*/
    const [holdDeletion, setHoldDeletion] = useState<boolean>(false)


    /*-----------------------------
     *           REQUEST
     * ----------------------------*/
    const deleteCartItemHttp = useHttp<DynamicObject>(configDeleteCartItemApi)

    const deleteCartItem = (id: string) => {

        if(props.item.deletionConfirmation){
        Swal.fire({
            icon: 'warning',
            html: `<div class="pe-10 ps-10 fw-bolder"><h3>${props.item.deletionConfirmation.title?.text}</h3><p>${props.item?.deletionConfirmation?.description?.text}</p></div>`,
            buttonsStyling: false,
            showCancelButton: true,
            cancelButtonText: t('cart.item.delete.popup.no'),
            showLoaderOnConfirm: true,
            confirmButtonText: t('cart.item.delete.popup.yes'),
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-light-danger',
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            if (result.isConfirmed) {
                deleteCartItemHandler(id, () => {
                    window.location.href = props.referral_url
                })
            }
          })
        } else {
            deleteCartItemHandler(id)
        }
    }

    const deleteCartItemHandler = (id, onDeleted?: () => void) => {
      if (props.disableActions) return;
        props.setDisableActions && props.setDisableActions(true);
        const requestDeleteCartItem = deleteCartItemHttp.request


        const success = (response: AxiosResponse) => {
            if (response.data.success) {
                setHoldDeletion(false)
                props.deleteFromList(response.data.deletedId)
                props.handleCart({cart: response.data.cart, buyButton: response.data.labels?.buyButton, action: response.data?.action})
                props.setDisableActions && props.setDisableActions(false);
                onDeleted && onDeleted()
            } else {
                props.setDisableActions && props.setDisableActions(false);
            }
        }
        const error = (error: AxiosError) => {
            props.setDisableActions &&
                props.setDisableActions(false);
            navigate(process.env.REACT_APP_404_REDIRECT)
        }

        requestDeleteCartItem({
            config: {
                memberId: memberId,
                cartId: cartId,
                identification: identification,
                id: id
            },
            callbacks: {
                success,
                error,
            }
        })
    }

    return (
        <div dir={i18n.language=='en'?'ltr':'rtl'}  className={`${style.item_container} ${props.borderFix ? style.border : ''}`}>
            <div className={`${style.item_wrapper}`}>
                <Row className={`${style.item_row} align-items-start`}>
                    {/* Icon */}
                    <Col sm={2} lg={2} xl={2} md={2} xs={2} className={`${style.item_col} pt-1`}>
                        <img src={props.item.icon} className={style.item_img} alt={''}/>
                    </Col>
                    {/* Service label + labels + delete */}
                    <Col className={`${style.item_margin}`}>
                        <span className={`${style.size_text}`}>
                            <b>{props.item.serviceLabel}</b>
                        </span>
                        <div className="d-flex flex-column gap-1 mt-1">
                            {props.item.label.map((labelItem, index) => (
                                <div key={index} className={`${style.size_text} d-flex align-items-center gap-1`}>
                                    {labelItem.icon && (
                                        <img src={getGeneralImage(labelItem.icon)} alt="" style={{ width: 16, height: 16, flexShrink: 0 }} />
                                    )}
                                    <span
                                        style={{
                                            color: labelItem.textColor,
                                            fontWeight: labelItem.style?.bold ? "bold" : "normal",
                                            textDecoration: labelItem.style?.underline ? "underline" : "none",
                                        }}
                                    >
                                        {labelItem.text}
                                    </span>
                                </div>
                            ))}
                            {props?.item?.showDelete &&
                                <p className={`${style.trash_btn} ${style.hoverPointer} p-0 text-primary`} onClick={() => {
                                        deleteCartItem(props.item.id)
                                    }}
                                    style={{
                                        cursor: props.disableActions ? "not-allowed" : "pointer",
                                    }}
                                >
                                    {t('cart.item.delete')}
                                </p>}
                        </div>
                    </Col>
                    {/* Price */}
                    <Col xs="auto" className="text-end pe-2">
                        {props.item.oldPrice?.text && (
                            <div
                                className={style.size_text}
                                style={{
                                    color: props.item.oldPrice.textColor,
                                    textDecoration: props.item.oldPrice.style?.strikeThrough ? "line-through" : "none",
                                    fontSize: "13px",
                                }}
                            >
                                {props.item.oldPrice.text}
                            </div>
                        )}
                        <span className={style.size_text}>
                            <b>{props.item.countryPrice}</b>
                        </span>
                    </Col>
                </Row>
            </div>
            {/* {props.clearFix ? <hr className={style.item_seperator}/> : ''} */}
        </div>
    )
}

export default CartItem
